import { Box, Icon } from '@zillow/constellation-10';
import { IconUserAddFilled } from '@zillow/constellation-icons';

import ConnectedModuleCard from '../../../ConnectedModuleCard';
import ListingActivationTerm from '../../../../components/ListingActivationTerms';
import ApplicationShareLinks from '../ApplicationShareLinks';

import {
  EmptyStateBodyText,
  EmptyStateTitleText,
  StyledEmptyStateContainer,
  StyledIconContainer,
} from '../../../../styles';

import type { ApplicationsSummary } from '../../interfaces';

type Props = {
  applicationsSummary?: ApplicationsSummary;
};

const EmptyApplicationsCard = ({ applicationsSummary }: Props) => (
  <ConnectedModuleCard data-testid="EmptyApplicationsCard">
    <StyledEmptyStateContainer>
      <StyledIconContainer aria-hidden="true">
        <Icon size="md" css={{ color: 'icon.subtle' }} render={<IconUserAddFilled />} />
      </StyledIconContainer>

      <EmptyStateTitleText asChild>
        <h4>No new applications</h4>
      </EmptyStateTitleText>

      <EmptyStateBodyText asChild>
        <p>
          You can invite renters to apply or wait for renters to apply via your listing on Zillow, Trulia, and HotPads.
          Applications received in the last 90 days will appear here.
        </p>
      </EmptyStateBodyText>

      <ApplicationShareLinks
        isTertiaryButtonStyling={false}
        hideViewOlderApplications={false}
        applicationsSummary={applicationsSummary}
      />

      <Box css={{ marginBottom: 'default' }} />
      <ListingActivationTerm actionText="By enabling or sharing applications" />
    </StyledEmptyStateContainer>
  </ConnectedModuleCard>
);

export default EmptyApplicationsCard;
